(() => {
  if (window.brioLocalizationSubmitBound) return;
  window.brioLocalizationSubmitBound = true;
  let pending = false;
  const storageKey = 'brio-language-position';

  const capturePosition = () => {
    const sections = [...document.querySelectorAll('main > .shopify-section[id]')];
    const section = sections.find(node => {
      const rect = node.getBoundingClientRect();
      return rect.top <= 80 && rect.bottom > 80;
    });
    const rect = section?.getBoundingClientRect();
    return {
      x: scrollX, y: scrollY, section: section?.id,
      fraction: rect?.height ? (80 - rect.top) / rect.height : 0,
      videoTime: document.querySelector('.brio-hero-video')?.currentTime || 0
    };
  };

  // Warm only theme styles and the incoming hero. The current page stays painted.
  const preparePage = async (html, url) => {
    const next = new DOMParser().parseFromString(html, 'text/html');
    const tasks = [];
    next.querySelectorAll('link[rel="stylesheet"]').forEach(link => {
      const href = new URL(link.getAttribute('href'), url).href;
      if (!/\/assets\/brio-[^/]+\.css(?:\?|$)/.test(href)) return;
      tasks.push(new Promise(resolve => {
        const preload = document.createElement('link');
        preload.rel = 'preload'; preload.as = 'style'; preload.href = href;
        preload.onload = preload.onerror = () => { preload.remove(); resolve(); };
        document.head.append(preload);
      }));
    });
    const sources = new Set();
    next.querySelectorAll('link[rel="preload"][as="image"]').forEach(link => {
      if (!link.media || matchMedia(link.media).matches) sources.add(link.getAttribute('href'));
    });
    next.querySelectorAll('main img[fetchpriority="high"], .pdp-studio.is-active img, .brio-hero-video[poster]').forEach(node => {
      sources.add(node.getAttribute('src') || node.getAttribute('poster'));
    });
    [...sources].filter(Boolean).slice(0, 6).forEach(source => {
      tasks.push(new Promise(resolve => {
        const image = new Image();
        image.onload = () => image.decode().catch(() => {}).then(resolve);
        image.onerror = resolve;
        image.src = new URL(source, url).href;
      }));
    });
    let timeout;
    await Promise.race([Promise.all(tasks), new Promise(resolve => { timeout = setTimeout(resolve, 2500); })]);
    clearTimeout(timeout);
    return next;
  };

  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('form.brio-language-form') || form.dataset.nativeFallback) return;
    const submitter = event.submitter;
    if (!submitter?.value) return;
    event.preventDefault();
    if (pending) return;
    if (submitter.value === document.documentElement.lang.split('-')[0]) {
      form.closest('details').open = false;
      return;
    }
    pending = true;
    const returnTo = form.querySelector('input[name="return_to"]');
    if (returnTo) returnTo.value = location.pathname + location.search;
    const data = new FormData(form);
    data.set(submitter.name, submitter.value);
    const position = capturePosition();
    const buttons = [...form.querySelectorAll('button')];
    buttons.forEach(button => { button.disabled = true; });
    form.setAttribute('aria-busy', 'true');
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    try {
      // Shopify sets the native language preference without unloading this document.
      const response = await fetch(form.action, { method: 'POST', body: data,
        credentials: 'same-origin', redirect: 'follow', signal: controller.signal });
      if (!response.ok) throw new Error('Language response failed');
      const target = new URL(response.url);
      if (target.origin !== location.origin) throw new Error('Unexpected language destination');
      const next = await preparePage(await response.text(), target.href);
      if (next.documentElement.lang.split('-')[0] !== submitter.value) throw new Error('Language unavailable');
      target.hash = '';
      try {
        sessionStorage.setItem(storageKey, JSON.stringify({ ...position,
          path: target.pathname, hash: location.hash, time: Date.now(), language: submitter.value }));
      } catch (_) { /* Native navigation still works when storage is unavailable. */ }
      form.closest('details').open = false;
      location.assign(target.href);
    } catch (_) {
      buttons.forEach(button => { button.disabled = false; });
      form.removeAttribute('aria-busy');
      pending = false;
      form.dataset.nativeFallback = 'true';
      form.requestSubmit(submitter);
    } finally {
      clearTimeout(timeout);
    }
  });
})();
